export function addErrorMsg ({ inputName, msg }) {
  const [$input] = document.getElementsByName(inputName)
  const $inputWrap = $input.parentElement

  const error = document.createElement('p')
  error.textContent = msg
  error.classList.add('wm-form__error')

  const thereIsError = $inputWrap.querySelectorAll('.wm-form__error').length > 0

  if (thereIsError) return
  $inputWrap.appendChild(error)
}
